import apiRequest from "./apiConfig";
import { endpoints, apiVersion } from "./endpoints";

export function loginApi(payload) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.login,
    method: 'post',
    payload
  })
}